import React from 'react';
import { Row } from 'antd';
import OnTraccrTextInput from '../../../common/inputs/OnTraccrTextInput';
import OptionalRow from './OptionalRow';
import ConditionalRenderingRow from './ConditionalRenderingRow';

import TimeTrackingGridPreview from './TimeTrackingGrid/TimeTrackingGridPreview';
import TitleRow from './TitleRow';
import { TablePreload } from './TablePreload/TablePreload';
import OnTraccrCheckbox from '../../../common/inputs/OnTraccrCheckbox';
import HideIfEmptyInPDFCheckbox from './HideIfEmptyInPDFCheckbox';

const configure = ({
  id,
  sections,
  setConfigProps,
  configProps = {},
  disableOptional,
  setCanSubmit,
  customers = [],
  projects = [],
  users = [],
  costcodes = [],
  costcodesLoading = false,
  phases = [],
  projectIdMap = {},
  vendors = [],
  equipment = [],
  formTemplates = [],
  labels = [],
  contactAddressBooks = {},
  buckets = [],
  scheduleCategories = [],
  divisions = [],
  templateId,
  isV3Form = false,
}) => {
  const {
    optional,
    title,
    hasConditionalRendering = false,
    conditionalRenderingFormula,
    isProjectRequired = false,
    isCostcodeRequired = false,
  } = configProps;

  const setTitle = (e) => {
    const {
      target: {
        value,
      } = {},
    } = e;
    setConfigProps({
      ...configProps,
      title: value,
    });
    setCanSubmit(value);
  };

  const updateCheckbox = (key) => (checked) => {
    setConfigProps({
      ...configProps,
      [key]: checked,
    });
  };

  const setConditionalRenderingFormula = (formula) => {
    setConfigProps({
      ...configProps,
      conditionalRenderingFormula: formula,
    });
  };

  const updatePreloadSettings = (newVal = {}) => {
    setConfigProps({
      ...configProps,
      ...newVal,
    });
  };

  const onCheckChanged = (key) => (checked) => {
    setConfigProps({
      ...configProps,
      [key]: checked,
    });
  };

  return (
    <div>
      <Row className="form-required-field">
        Title:
      </Row>
      <Row style={{ marginTop: 5 }}>
        <OnTraccrTextInput
          textarea
          placeholder="Insert title here"
          onChange={setTitle}
          value={title}
        />
      </Row>
      <OptionalRow
        onChange={updateCheckbox('optional')}
        optional={optional}
        disabled={disableOptional}
      />
      <ConditionalRenderingRow
        onFormulaChange={setConditionalRenderingFormula}
        conditionalRenderingFormula={conditionalRenderingFormula}
        onChange={updateCheckbox('hasConditionalRendering')}
        hasConditionalRendering={hasConditionalRendering}
        sections={sections}
        id={id}
        customers={customers}
        projects={projects}
        users={users}
        costcodes={costcodes}
        phases={phases}
        projectIdMap={projectIdMap}
        vendors={vendors}
        equipment={equipment}
        formTemplates={formTemplates}
        labels={labels}
        contactAddressBooks={contactAddressBooks}
        buckets={buckets}
        scheduleCategories={scheduleCategories}
      />
      <HideIfEmptyInPDFCheckbox
        isV3Form={isV3Form}
        configProps={configProps}
        setConfigProps={setConfigProps}
      />
      <OnTraccrCheckbox
        style={{ marginTop: 10 }}
        value={isProjectRequired}
        onChange={onCheckChanged('isProjectRequired')}
        label="Project Required?"
        hoverNode={(
          <div style={{ width: 250 }}>
            Check this box if you want the project to be required when adding a new column
          </div>
        )}
      />
      <OnTraccrCheckbox
        style={{ marginTop: 10 }}
        value={isCostcodeRequired}
        onChange={onCheckChanged('isCostcodeRequired')}
        label="Costcode Required?"
        hoverNode={(
          <div style={{ width: 250 }}>
            Check this box if you want the costcode to be required when adding a new column
          </div>
        )}
      />
      <TablePreload
        configProps={configProps}
        updateConfig={updatePreloadSettings}
        sections={sections}
        divisions={divisions}
        costcodes={costcodes}
        costcodesLoading={costcodesLoading}
        templateId={templateId}
        isTimeTrackingGrid
      />
    </div>
  );
};

const preview = ({
  id,
  responses = {},
  configProps = {},
  previewProps = {},
  responding = false,
  divisions = [],
  setResponses,
  isDisplay = false,
  costcodes = [],
  fetchProjectCostcodes,
} = {}) => {
  const {
    title,
    optional,
  } = configProps;

  return (
    <div style={{ pointerEvents: 'auto' }}>
      <TitleRow
        title={title}
        optional={optional}
        style={{ marginTop: 10, marginBottom: 10 }}
      />
      <TimeTrackingGridPreview
        id={id}
        responses={responses}
        configProps={configProps}
        previewProps={previewProps}
        responding={responding}
        divisions={divisions}
        setResponses={setResponses}
        isDisplay={isDisplay}
        costcodes={costcodes}
        fetchProjectCostcodes={fetchProjectCostcodes}
      />
    </div>
  );
};

export default {
  configure,
  preview,
  title: 'Time Tracking Grid',
  description: 'Table to track time entries',
  paidFlag: 'TIME_TRACKING_GRID',
};
